"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FraudFlagReason = void 0;
/** @TranslateToPython */
var FraudFlagReason;
(function (FraudFlagReason) {
    // Reasons a notary can select, see NOTARY_FRAUD_FLAG_REASONS in aven_frontend/aven_notary/src/utils/systemFraudFlagsHelper.ts
    FraudFlagReason["coercion"] = "coercion";
    FraudFlagReason["languageBarriers"] = "languageBarriers";
    FraudFlagReason["suspicious"] = "suspicious";
    FraudFlagReason["verbalKBAFailure"] = "verbalKBAFailure";
    FraudFlagReason["documentIssue"] = "documentIssue";
    // Raised automatically once the borrowers attempt Persona, so a notary does not select it; /notary/flagFraudAccount still accepts it from older notary bundles.
    // NOTE: if DLAddressMismatch is the only reason on the fraud flag, then the fraud flag is considered not active and DLMismatch is processed in a separate queue
    // However we still need to flag it within fraud flag given the current data structure
    FraudFlagReason["DLAddressMismatch"] = "DLAddressMismatch";
    // Deprecated reasons to notary UI
    FraudFlagReason["_legalPropertyDescription"] = "legalPropertyDescription";
    FraudFlagReason["_notInHome"] = "notInHome";
    FraudFlagReason["_other"] = "other";
    FraudFlagReason["_prompting"] = "prompting";
    // Notary endpoint reasons, i.e. idology verification
    FraudFlagReason["SSNMismatch"] = "SSNMismatch";
    FraudFlagReason["KBALockedOut"] = "KBALockedOut";
    FraudFlagReason["KbaAllowableFail"] = "KbaAllowableFail";
    FraudFlagReason["KbaNoQuestions"] = "KbaNoQuestions";
    FraudFlagReason["KbaPassWithQuestions"] = "KbaPassWithQuestions";
    // Reasons automatically detected by system
    FraudFlagReason["_errorFetchingPropertyDescription"] = "errorFetchingPropertyDescription";
    FraudFlagReason["_inSessionPersonaVerificationNeedsReview"] = "inSessionPersonaVerificationNeedsReview";
    FraudFlagReason["preSessionPersonaVerificationNeedsReview"] = "preSessionPersonaVerificationNeedsReview";
    FraudFlagReason["preSessionPersonaVerificationFailed"] = "preSessionPersonaVerificationFailed";
    FraudFlagReason["NOOSecondaryResidenceType"] = "NOOSecondaryResidenceType";
    FraudFlagReason["_sentiLinkInformationMismatch"] = "sentiLinkInformationMismatch";
    FraudFlagReason["sentiLinkAbuseOrIdTheftScore"] = "sentiLinkAbuseOrIdTheftScore";
    FraudFlagReason["ofacFailedOnCoOwner"] = "ofacFailedOnCoOwner";
    FraudFlagReason["ofacFailedOnApplicant"] = "ofacFailedOnApplicant";
    FraudFlagReason["proveVerifyFlaggedAfterSlLnFlagged"] = "proveVerifyFlaggedAfterSlLnFlagged";
    FraudFlagReason["lexisNexisFraudIntelligenceFlagged"] = "lexisNexisFraudIntelligenceFlagged";
    FraudFlagReason["seonReviewFlagged"] = "seonReviewFlagged";
    FraudFlagReason["seonDeclineFlagged"] = "seonDeclineFlagged";
    FraudFlagReason["experianFraudFlagFound"] = "experianFraudFlagFound";
    FraudFlagReason["_lexisNexisRickIndicator"] = "lexisNexisRickIndicator";
    FraudFlagReason["multipleSSNAttemptsPerPhone"] = "multipleSSNAttemptsPerPhone";
    // deprecated per https://app.asana.com/0/1201603871777260/1203792037465498/f
    FraudFlagReason["_largeTxnOrBTCO"] = "largeTxnOrBTCO";
    // Applicant changed their phone number during OG
    FraudFlagReason["phoneNumberChanged"] = "phoneNumberChanged";
    // NGMI'ed accounts' bank account via Plaid income verification
    FraudFlagReason["ngmiBankAccountFromPlaid"] = "ngmiBankAccountFromPlaid";
    // Applicant shares PII with a fraud-blocked (NGMI'd) applicant
    FraudFlagReason["relatedNgmidLoanApplication"] = "relatedNgmidLoanApplication";
    /**
     * @deprecated Replaced by the liensPositionVerification contingency routing to the liens team. Kept with its
     * original string value so historical fraud_signal.name rows still match.
     */
    FraudFlagReason["_additionalLienFound"] = "additionalLienFound";
    // Home owners changes found during notarization.
    FraudFlagReason["homeOwnersChangesFound"] = "homeOwnersChangesFound";
    // Test flag reason
    FraudFlagReason["testReasonEnum"] = "testReasonEnum";
    /**
     * @deprecated
     */
    FraudFlagReason["_missingIdentityVerification"] = "missingIdentityVerification";
    FraudFlagReason["missingKBAVerification"] = "missingKBAVerification";
    FraudFlagReason["missingPersonaVerification"] = "missingPersonaVerification";
    // Raised when an applicant whose loan application opted into soft-fail (traits.idologyExpectIdSoftFailRule)
    // fails IDology's initial ExpectID call (fail/error) during origination. Applicant continues; ops review + 2 additional forms of ID at notary.
    FraudFlagReason["idologyExpectIdSoftFail"] = "idologyExpectIdSoftFail";
})(FraudFlagReason || (exports.FraudFlagReason = FraudFlagReason = {}));
